"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
require("moment-timezone");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Day = _interopRequireDefault(require("./Day"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var DaysConainer = _styledComponents["default"].nav(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  padding: var(--padding);\n\n  span {\n    height: 45px;\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    margin: 8px 0;\n    position: relative;\n\n    &.label {\n      text-transform: uppercase;\n      font-size: 14px;\n      font-weight: 700;\n      color: rgba(0, 0, 0, 0.3);\n    }\n  }\n"])));
var Days = function Days(_ref) {
  var dates = _ref.dates,
    setDates = _ref.setDates,
    onUpdateDates = _ref.onUpdateDates,
    maxDays = _ref.maxDays,
    blockAfterToday = _ref.blockAfterToday;
  var today = (0, _moment["default"])().endOf('day'); // Consider the end of today

  var labels = (0, _react.useMemo)(function () {
    return Array.from({
      length: 7
    }, function (_, i) {
      return (0, _moment["default"])().day(i + 1).format('ddd');
    });
  }, []);
  var thisDate = (0, _moment["default"])(dates === null || dates === void 0 ? void 0 : dates.date);
  var daysInMonth = (0, _moment["default"])(dates === null || dates === void 0 ? void 0 : dates.date).daysInMonth();
  var firstDayDate = (0, _moment["default"])(dates === null || dates === void 0 ? void 0 : dates.date).startOf('month');
  var prevMonth = (0, _moment["default"])(dates === null || dates === void 0 ? void 0 : dates.date).subtract(1, 'month');
  var prevMonthDays = prevMonth.daysInMonth();
  var nextMonth = (0, _moment["default"])(dates === null || dates === void 0 ? void 0 : dates.date).add(1, 'month');
  var generateDays = function generateDays(start, end, month) {
    var generatedDays = [];
    for (var i = start; i <= end; i += 1) {
      var day = (0, _moment["default"])(month).date(i).startOf('day');
      generatedDays.push({
        id: day.format('DD MM YYYY'),
        day: day
      });
    }
    return generatedDays;
  };
  var prevMonthArr = generateDays(prevMonthDays - firstDayDate.day() + 2, prevMonthDays, prevMonth);
  var currentMonthArr = generateDays(1, daysInMonth, thisDate);
  var nextMonthArr = generateDays(1, 42 - (prevMonthArr.length + currentMonthArr.length), nextMonth);
  var allDays = [].concat(_toConsumableArray(prevMonthArr), _toConsumableArray(currentMonthArr), _toConsumableArray(nextMonthArr));
  var isSelectable = function isSelectable(date) {
    return date.isSameOrBefore(today, 'day');
  };
  var changeDate = function changeDate(selectedDate) {
    if (blockAfterToday && !isSelectable(selectedDate)) {
      return;
    }
    if (!(dates !== null && dates !== void 0 && dates.startDate)) {
      // when selecting the start date
      setDates(_objectSpread(_objectSpread({}, dates), {}, {
        startDate: selectedDate,
        endDate: null
      }));
    } else if (dates !== null && dates !== void 0 && dates.startDate && !(dates !== null && dates !== void 0 && dates.endDate)) {
      // when selecting a endDate after the startDate 
      if ((selectedDate.isAfter(dates === null || dates === void 0 ? void 0 : dates.startDate, 'day') || selectedDate.isSame(dates === null || dates === void 0 ? void 0 : dates.startDate, 'day')) && (maxDays === 0 || selectedDate.diff(dates === null || dates === void 0 ? void 0 : dates.startDate, 'days') <= maxDays)) {
        setDates(_objectSpread(_objectSpread({}, dates), {}, {
          endDate: selectedDate
        }));
      } else {
        setDates(_objectSpread(_objectSpread({}, dates), {}, {
          startDate: selectedDate,
          endDate: null
        }));
      }
    } else if (dates !== null && dates !== void 0 && dates.startDate && dates !== null && dates !== void 0 && dates.endDate) {
      // when selecting a date after the end date
      setDates(_objectSpread(_objectSpread({}, dates), {}, {
        startDate: selectedDate,
        endDate: null
      }));
    }
  };
  (0, _react.useEffect)(function () {
    onUpdateDates(dates);
  }, [dates, onUpdateDates]);
  return /*#__PURE__*/_react["default"].createElement(DaysConainer, null, labels.map(function (label) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: label,
      className: "label"
    }, label);
  }), allDays.map(function (day) {
    return /*#__PURE__*/_react["default"].createElement(_Day["default"], {
      key: day.id,
      date: day,
      currentDate: dates === null || dates === void 0 ? void 0 : dates.date,
      startDate: dates === null || dates === void 0 ? void 0 : dates.startDate,
      endDate: dates === null || dates === void 0 ? void 0 : dates.endDate,
      onClick: function onClick() {
        return changeDate(day.day);
      }
    });
  }));
};
Days.propTypes = {
  dates: _propTypes["default"].shape().isRequired,
  setDates: _propTypes["default"].func.isRequired,
  onUpdateDates: _propTypes["default"].func.isRequired,
  maxDays: _propTypes["default"].number,
  blockAfterToday: _propTypes["default"].bool
};
Days.defaultProps = {
  maxDays: 0,
  blockAfterToday: true
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(Days);